module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/babel-runtime/core-js/object/get-prototype-of.js
 ** module id = 1499
 ** module chunks = 0
 **/